<template>
  <v-hover>
    <template v-slot:default="{ isHovering, props }">
      <div ref="icon">
        <v-icon :icon="DragIcon" :size="size" v-bind="props"
                :color="isHovering ? 'primary' : color" class="drag-icon-element"
                @click="props.onMouseleave()"
                :class="{hover: isHovering, [customClass]: true}"
                :style="{ visibility: showDrag ? 'visible' : 'hidden' }"/>
      </div>
      <teleport to="body" v-if="showOnboarding">
        <div :style="spotlightStyle" class="spotlight">
          <v-icon :icon="DragIcon" :size="size" v-bind="props"
                  :color="isHovering ? 'primary' : color"
                  :class="{hover: isHovering, [customClass]: true}"
                  :style="{ visibility: showDrag ? 'visible' : 'hidden' }"/>
        </div>
      </teleport>

      <v-menu
          :model-value="showOnboarding"
          :location="left ? 'end center' : 'start center'"
          z-index="2222"
          activator="parent"
          :close-on-content-click="false"
          transition="fade-transition"
          :target="icon"
          :offset="[14]"
          @update:model-value="sentHint"
      >
        <div class="d-flex align-center">
          <div class="d-flex justify-center" v-if="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="40" viewBox="0 0 10 40" fill="none" :class="{'rotate-icon': left}">
              <path d="M10 19.9508L7.00113 16.9419C2.51758 12.4434 -3.48472e-07 6.35102 -7.08473e-08 -0.000296911L-1.81503e-06 39.9019C-1.5374e-06 33.5506 2.51758 27.4583 7.00113 22.9597L10 19.9508Z" fill="white"/>
            </svg>
          </div>
          <div class="onboarding">
            {{$t('Удерживайте, чтобы изменить порядок')}}
            <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="sentHint">
              {{ $t('Понятно') }}
            </v-btn>
          </div>
          <div class="d-flex justify-center" v-if="!left">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="40" viewBox="0 0 10 40" fill="none">
              <path d="M10 19.9508L7.00113 16.9419C2.51758 12.4434 -3.48472e-07 6.35102 -7.08473e-08 -0.000296911L-1.81503e-06 39.9019C-1.5374e-06 33.5506 2.51758 27.4583 7.00113 22.9597L10 19.9508Z" fill="white"/>
            </svg>
          </div>
        </div>
      </v-menu>
    </template>
  </v-hover>
  <v-overlay
      :model-value="showOnboarding"
      :scrim="true"
      opacity="0.7"
      persistent
      style="z-index: 2000"
  />
</template>

<script setup lang="ts">
import DragIcon from "~/assets/icons/drag.vue";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {useHintStore} from "@/stores/hintStore";

const hintStore = useHintStore()
const onboarding = ref(false)
const icon = ref()
const spotlightStyle = ref({})

const props = defineProps({
  showDrag: { type: Boolean, default: true },
  customClass: { type: String },
  size: { type: String },
  color: { type: String },
  left: { type: Boolean }
})

const sentHint = () => {
  onboarding.value = false
  hintShowed.value = true
  hintStore.closeHint('reorder_blocks')
}

const hintShowed = ref(false)
const dataLoaded = ref(false)
onMounted(() => {
  if(props.showDrag) {
    loadAndShowHint()
  }
})

const loadAndShowHint = () => {
  if(dataLoaded.value) {
    onboarding.value = !hintShowed.value;
  } else {
    hintStore.checkHint('reorder_blocks').then(result => {
      hintShowed.value = result
      onboarding.value = !result
      if(onboarding.value) {
        hintStore.viewHint('reorder_blocks')
      }
      dataLoaded.value = true
    })
  }
}

const showOnboarding = computed(() => {
  return !!onboarding.value && hintStore.canShow('reorder_blocks')
})

watch(() => props.showDrag, (show) => {
  if(show && !hintShowed.value) {
    loadAndShowHint()
  }
})

watch(onboarding, async (val) => {
  if (!val) return
  await nextTick()

  const el = icon.value
  if (!el) return

  const rect = el.getBoundingClientRect()
  const size = (rect.width > rect.height ? rect.width : rect.height) + 10
  spotlightStyle.value = {
    position: 'fixed',
    top: `${rect.top - ((size - rect.height)/2)}px`,
    left: `${rect.left - ((size - rect.width)/2)}px`,
    width: `${size}px`,
    height: `${size}px`,
  }
})
</script>

<style scoped lang="sass">
.onboarding
  padding: 20px
  background: #fff
  display: flex
  justify-content: center
  flex-direction: column
  gap: 16px
  border-radius: 10px
  color: #363636
  text-align: center
  font-size: 16px
  font-weight: 400
  max-width: 246px

.drag-icon-element
  &.hover
    border-radius: 20px
    background: #E7F3FD

.rotate-icon
  transform: rotate(180deg)

.spotlight
  z-index: 3000
  background-color: white !important
  border-radius: 100%
  display: flex
  align-items: center
  justify-content: center
</style>
